import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { ModalController, NavController, NavParams, Platform } from '@ionic/angular';
import { StatusBar } from '@ionic-native/status-bar/ngx';
import { AngularFireDatabase } from '@angular/fire/database';
import { authenticationService } from 'src/app/Services/Authentication/authentication.service';
import { IonContent, IonInput, IonTextarea, ActionSheetController } from '@ionic/angular';
import { Keyboard } from '@ionic-native/keyboard/ngx';
import { AssureurService } from 'src/app/Services/Assureur/assureur.service';
import { Observable } from 'rxjs';
import { FactoryService } from 'src/app/Services/historique/factory.service';
import { Route } from '@angular/compiler/src/core';
import { Router } from '@angular/router';
@Component({
  selector: 'app-resume',
  templateUrl: './resume.page.html',
  styleUrls: ['./resume.page.scss'],
})
export class ResumeComponent implements OnInit {
 status:any
  constructor(private modalController: ModalController,private _router:Router,
    private sb: StatusBar ,private plt:Platform,private nvparms:NavParams ,
    private _factory:FactoryService

    
    ) {
      this.status = this.nvparms.get('value');
      // console.log(this.status);
      // console.log(this._factory.getData(150));
      
      this.plt.ready().then(() => {
        //this.sb.overlaysWebView(true)
        this.sb.backgroundColorByHexString("#405d84");
        
      });
     }

  ngOnInit() {

  }
  retour(){
    this.plt.ready().then(() => {
      //this.sb.overlaysWebView(true)
      this.sb.backgroundColorByHexString("#1474fe");
      
    });
    //
    
    this.modalController.dismiss()
  }
  lancerSimul(){
      if (this.status==="guide") {
       this.modalController.dismiss()
        setTimeout(() => {
          this._router.navigate(['/sous-auto-step0'])
        }, 100);
     
      //this._router.navigate(['/formulaireauto'])
      return
      }

    this._factory.lancerPrime.next("ok")
    this.modalController.dismiss()
  }

}
